<template>
    <div class="dvgraficobarra">
        <v-chart :options="options"/>
    </div>
</template>
<style>
</style>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

import 'echarts/theme/dark'
import util from '../utilitarios/util.js'

export default {
    name : "cmpgraficobar",
    components: {
        'v-chart': ECharts
    },
    props:[		
        'titulo',
        'agrupamento',
			'series'
    ],
    computed:{
        temaSistema(){
            return this.$store.state.temasistema;
        },
        options(){
            return {
                title: {
                    text: this.titulo || ''
                },
                color: util.gerarpaletagrafico(this.temaSistema, 11),
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    show : false,
                    left: '0',
                    right: '0',
                    bottom: '0',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show  : false,
                            title : 'Salvar gráfico'
                        }
                    }
                },
                xAxis: {
                    data: this.agrupamento || [],
                    show: true
                },
                yAxis: {
                    type: 'value',
                    show : true
                },
                series: {
                    data: this.series || [],
                    type: 'bar',
                    showBackground: false
                }
            };
        }
    }    
}
</script>
